import * as React from 'react';
import { SVGProps } from 'react';

const SvgGiftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.318 4.636a1.227 1.227 0 0 0-.012 2.455h2.593a6.724 6.724 0 0 0-.383-.833c-.514-.936-1.221-1.622-2.198-1.622ZM5.455 5.864c0 .428.096.847.276 1.227H3.818A.818.818 0 0 0 3 7.909v4.09c0 .453.366.82.818.82h.818v7.363c0 .452.367.818.819.818h13.09a.818.818 0 0 0 .819-.818v-7.364h.818A.818.818 0 0 0 21 12V7.909a.818.818 0 0 0-.818-.818h-1.913A2.864 2.864 0 0 0 15.682 3c-1.887 0-3.021 1.36-3.632 2.47l-.05.092a7.483 7.483 0 0 0-.05-.093C11.34 4.36 10.205 3 8.318 3a2.864 2.864 0 0 0-2.863 2.864Zm10.24 1.227H13.1c.1-.261.227-.549.383-.833.515-.936 1.221-1.622 2.198-1.622a1.227 1.227 0 0 1 .012 2.455Zm-2.877 1.636v2.455h6.546V8.727H12.818Zm-8.182 0H11.182v2.455H4.636V8.727Zm6.546 4.091h-4.91v6.546h4.91v-6.546Zm1.636 6.546v-6.546h4.91v6.546h-4.91Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgGiftIcon;
